"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.responseSchema = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({
    dateFrom: zod_1.z.string().datetime(),
    dateTo: zod_1.z.string().datetime(),
    lngLat: zod_1.z.string(),
});
exports.responseSchema = zod_1.z.object({
    overrides: zod_1.z.record(zod_1.z.string(), // depth e.g., "-5", "-15", "-25", etc.
    zod_1.z.object({
        depth: zod_1.z.string(),
        fieldCapacity: zod_1.z.number(),
        permanentWiltingPoint: zod_1.z.number(),
    })),
    lastGoodReading: zod_1.z.string(), // ISO date string
});
exports.path = '/soil-calibration-settings-get';
//# sourceMappingURL=index.js.map